import { navigateTo } from 'nuxt/app'
import { getActivePinia } from 'pinia'
import { clearSavedGridFilters } from '~/utils/grid-filter-state'

/**
 * Ends the agent's session in this tab: the logout button, a 401 from any API
 * (a timed-out session or a forced sign-out) and a sign-out in another tab
 * (plugins/session-end-sync.client.js) all come here.
 *
 * Filter values go first, so a store that fails to reset cannot keep them.
 * Resetting the auth store then stops grid pages saving them again.
 */
export function endAgentSession() {
  clearSavedGridFilters()

  getActivePinia()._s.forEach((store) => store.$reset())

  navigateTo('/login')
}
